import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api/api';

export const sprintKeys = {
  all: ['sprints'] as const,
  byProject: (projectId: string) => [...sprintKeys.all, projectId] as const,
};

export const sprintsOptions = (projectId: string) =>
  queryOptions({
    queryKey: sprintKeys.byProject(projectId),
    queryFn: () => api.listSprints(projectId),
  });
